import {
	Button, Dialog, DialogTitle, DialogActions,
	DialogContent, DialogContentText, IconButton
} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import React from "react";
import Tooltip from '@material-ui/core/Tooltip'
import { useActions, useValues } from 'kea';
import { preferenceslogic } from "src/store/global";

const RemoveDialog = ({ OnRemove }) => {
	const [open, setOpen] = React.useState(false);
	const { geofence } = useValues(preferenceslogic);
	const { setGeofence } = useActions(preferenceslogic);


	const handleClickOpen = () => {
		setOpen(true);
		setGeofence({ ...geofence, drag: false });
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleRemove = () => {
		setOpen(false);
		OnRemove();
		setGeofence({ ...geofence, drag: true });
	}


	return (
		<>
			<Tooltip title='Geofence Remove'>
				<IconButton aria-label="delete" onClick={handleClickOpen}
					size='small'
				>
					<DeleteIcon
					/>
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Remove"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Remove the Geofence?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default RemoveDialog;
